/**
 * Data attributes used by Cypress form filler command to
 * identify types of input control.
 *
 * To be applied to base input components.
 */

const dataComponentAttrs = {
  bmText: "bm_text",
  bmTextArea: "bm_text_area",
  bmDropdown: "bm_dropdown",
  bmColourPicker: "bm_colour_picker",
  bmAddress: "bm_address",
} as const;

export type DataComponentAttrKeys =
  (typeof dataComponentAttrs)[keyof typeof dataComponentAttrs];

export default dataComponentAttrs;
